import React from 'react';





function About() {
  
  return(
          <div className="brand-area brand-bg" id='services'>
        <div className="container">
          <div data-aos="zoom-in" className="slider-content text-center">

          <h2>Współpraca</h2>

          </div>
          
          
        </div>
      </div>
  )
}

export default About;
